import dayjs from "dayjs";

import { formatEventDate } from "@/lib/format";
import type { PlayRequest } from "./api";

export function formatTime(iso: string): string {
  return formatEventDate(iso);
}

export function describeWhen(r: PlayRequest): string {
  switch (r.time_mode) {
    case "now":
      return "Сейчас";
    case "evening":
      return "Сегодня вечером";
    case "any":
      return `Неважно · до ${dayjs(r.match_until).format("D MMM")}`;
    case "exact":
      return formatTime(r.preferred_at);
  }
}

export function describeMode(mode: "rated" | "casual"): string {
  return mode === "rated" ? "На рейтинг · 1×1" : "Просто поиграть";
}
